import { useForm } from 'react-hook-form'
import { FormHTMLAttributes } from 'react'
import { BpInput } from '../../../../shared/components/forms/input/BpInput'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { EMAIL_REGEX, URL_REGEX } from '../../../../shared/consts/RegularExpressions.const'
import { useTranslation } from 'react-i18next'

export interface IDemoFormData {
  name: string
  email: string
  company: string
  website: string
  messenger: string
}

export interface IDemoFormProps extends FormHTMLAttributes<HTMLFormElement> {
  submitHandler?: (data: IDemoFormData) => void
  isFetching?: boolean
}

export const DemoRequestForm = ({
  submitHandler,
  isFetching = false,
  ...formProps
}: IDemoFormProps) => {
  const { t } = useTranslation()

  const {
    handleSubmit,
    register,
    formState: { errors, isValid },
  } = useForm<IDemoFormData>({ mode: 'onChange' })

  return (
    <>
      <h2 className='mb-[24px]'>{t('pages.audit.checkYourBrand')}</h2>
      <form
        {...formProps}
        className='flex flex-col gap-[16px]'
        onSubmit={handleSubmit((data: IDemoFormData) => {
          if (submitHandler) submitHandler(data)
        })}
      >
        <BpInput
          required
          error={errors.name?.message}
          fieldSize='lg'
          label={t('fields.fullName')}
          {...register('name', {
            required: t('fields.validate.required'),
            minLength: {
              value: 4,
              message: t('fields.validate.fullNameMinLength'),
            },
          })}
        />
        <BpInput
          required
          error={errors.email?.message}
          fieldSize='lg'
          label={t('fields.workEmail')}
          type='email'
          {...register('email', {
            required: t('fields.validate.emailRequired'),
            pattern: {
              value: EMAIL_REGEX,
              message: t('fields.validate.email'),
            },
          })}
        />
        <BpInput
          required
          error={errors.company?.message}
          fieldSize='lg'
          label={t('fields.company')}
          {...register('company', {
            required: t('fields.validate.companyNameRequired'),
            minLength: {
              value: 4,
              message: t('fields.validate.companyNameMinLength'),
            },
          })}
        />
        <BpInput
          required
          error={errors.website?.message}
          fieldSize='lg'
          label={t('fields.brandWebsite')}
          {...register('website', {
            required: t('fields.validate.required'),
            pattern: {
              value: URL_REGEX,
              message: t('fields.validate.invalidWebsiteAddress'),
            },
          })}
        ></BpInput>
        <BpInput
          error={errors.messenger?.message}
          fieldSize='lg'
          label={t('fields.messengerOptional')}
          {...register('messenger')}
        ></BpInput>
        <div className='mt-[16px] flex flex-col'>
          <BpButton
            className={'uppercase'}
            disabled={!isValid || isFetching}
            size='lg'
            type='submit'
          >
            {t('pages.demo.requestDemo')}
          </BpButton>
        </div>
      </form>
    </>
  )
}
